import React, { useRef, useState } from "react";
import Box from "@mui/material/Box/Box";
import { theme } from "../../special/genie-theme/genie-theme";
import GenieText from "../genie-text/GenieText";
import { ProductMedia } from "../../../types/api/Product";
import { Cancel } from "@mui/icons-material";

interface GenieThumbListProps {
  media: ProductMedia[];
  reorder: (media: ProductMedia[]) => void;
  remove: (item: ProductMedia) => void;
}

function GenieThumbList({ media, reorder, remove }: GenieThumbListProps) {
  const dragOverItem = useRef(null);
  const dragItem = useRef(null);

  const [phantom, setPhantom] = useState(-1);

  const dragStart = (e: any, position: any) => {
    dragItem.current = position;
    setPhantom(position);
  };

  const dragEnter = (e: any, position: any) => {
    dragOverItem.current = position;
    setPhantom(position);
  };

  const drop = (e: any) => {
    const currentDragItem = dragItem.current as unknown as number;
    const currentDragOver = dragOverItem.current as unknown as number;
    const copyListItems = [...media];
    const dragItemContent = copyListItems[currentDragItem];
    copyListItems.splice(currentDragItem, 1);
    copyListItems.splice(currentDragOver, 0, dragItemContent);

    for (let i = 0; i < copyListItems.length; i++) {
      copyListItems[i].display_order = i;
    }

    dragItem.current = null;
    dragOverItem.current = null;
    reorder(copyListItems);
    setPhantom(-1);
  };

  return (
    <>
      <GenieText fontSize={"tiny"} subdued>
        Note: Items can be reordered with drag & drag once they are added.
      </GenieText>
      {media.map((item, index) => (
        <Box
          m={1}
          sx={{
            position: "relative",
            display: "inline-block",
            backgroundImage: `url("${item.media.cloudinary_url}")`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            width: "80px",
            height: "80px",
            border:
              phantom === index
                ? `4px solid ${theme.palette.primary.light}`
                : "4px solid transparent",
            borderRadius: theme.shape.borderRadius,
            opacity: phantom !== index && phantom >= 0 ? 0.5 : 1,
            textAlign: "center",
            color: theme.palette.common.white,
            cursor: "grab",
            transition: theme.transitions.create(["opacity", "transform"]),
            "&:active": {
              cursor: "grabbing",
            },
          }}
          key={index}
          onDragOver={(e) => e.preventDefault()}
          onDragStart={(e) => dragStart(e, index)}
          onDragEnter={(e) => dragEnter(e, index)}
          onDragEnd={drop}
          draggable
        >
          <Box
            position={"absolute"}
            right={1}
            top={1}
            display={"flex"}
            bgcolor={"white"}
            borderRadius={1}
          >
            <Cancel
              fontSize={"small"}
              color={"error"}
              cursor={"pointer"}
              onClick={() => remove(item)}
            />
          </Box>
        </Box>
      ))}
    </>
  );
}

export default GenieThumbList;
